import React, { useEffect, useState } from 'react';
import { DeleteDialogUI, FileTabUI, TabsUI } from '../Interface';
import ExcelImportTab from '../Interface/ExcelImportTab';
import ItemPrice from './ItemPrice';
import MasterdataClassificationTab from '../MasterdataClassification/MasterdataClassificationTab';
import { MasterDataClassificationType } from '../../config/masterdataClassification';
import jokerService from '../../service/joker.service';
import { JokerTypes } from '../../config/joker';
import JokerTab from '../Interface/Joker/JokerTab';
import { useFormikContext } from 'formik';
import { v4 as uuidv4 } from 'uuid';
import ItemOtherPropsTab from './ItemOtherPropsTab';
import ItemAdditionalDataTab from './ItemAdditionalDataTab';

const ItemTabs = (props) => {
  const { setFieldValue, values } = useFormikContext();
  const { disabled } = props;
  const [activeTab, setActiveTab] = useState(0);
  const [deleteDialog, setDeletDialog] = useState(false);
  const [fileToDelete, setFileToDelete] = useState(null);
  const [jokerGroups, setJokerGroups] = useState([]);

  const handleUpload = (files) => {
    const filesWithId = files.map((file) => {
      file.id = uuidv4();
      return file;
    });

    const existingAttachments = Array.isArray(values.itemAttachment) ? values.itemAttachment : [];

    setFieldValue('itemAttachment', [...existingAttachments, ...filesWithId]);
  };

  const hideDeleteDialog = () => {
    setDeletDialog(false);
  };

  const handleRemoveElement = () => {
    setFieldValue(
      'itemAttachment',
      (values.itemAttachment || []).filter((itemAttachment) => itemAttachment.id !== fileToDelete.id)
    );

    setFileToDelete(null);
    hideDeleteDialog();
  };

  const getJokerGroups = async () => {
    jokerService.getGroups(JokerTypes.ITEM).then((data) => {
      setJokerGroups(data);
    });
  };

  useEffect(() => {
    getJokerGroups();
  }, []);

  const tabs = [
    {
      id: 0,
      name: 'Pénzügyi adatok',
      content: <ItemOtherPropsTab {...props} />,
    },
    {
      id: 1,
      name: 'További adatok',
      content: <ItemAdditionalDataTab {...props} />,
    },
    {
      id: 2,
      name: 'Adat import',
      content: <ExcelImportTab {...props} />,
    },
    {
      id: 3,
      name: 'Csatolmányok',
      content: (
        <FileTabUI
          savedFiles={values?.itemAttachment ?? []}
          handleDelete={(file) => {
            setFileToDelete(file);
            setDeletDialog(true);
          }}
          disabled={disabled}
          handleUpload={handleUpload}
        />
      ),
    },
    {
      id: 4,
      name: 'Besorolás',
      content: <MasterdataClassificationTab {...props} type={MasterDataClassificationType.ITEM} />,
    },
    {
      id: 5,
      name: 'Cikkárak',
      content: <ItemPrice {...props} />,
    },
    ...((jokerGroups.length > 0 &&
      jokerGroups
        .filter((group) => group.jokerFields.length > 0)
        .map((group, index) => ({
          id: index + 6,
          name: group.name,
          content: <JokerTab fields={group.jokerFields} key={index} {...props} />,
        }))) ||
      []),
  ];

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div className="my-4 mt-6">
      <div className="px-3">
        <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
          {tabs.map((tab, index) => (
            <div key={index} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </div>
      <DeleteDialogUI
        handleRemoveElement={handleRemoveElement}
        show={deleteDialog}
        onHide={() => {
          hideDeleteDialog();
          setFileToDelete(null);
        }}
      />
    </div>
  );
};

export default ItemTabs;
